// src/pages/Users/Techniques/components/TechniquesHero.jsx

import React from "react";

import {
  FaBookOpen,
  FaLayerGroup,
  FaSearch,
  FaVolumeUp,
} from "react-icons/fa";

export default function TechniquesHero({
  totalCount,
  filteredCount,
  familiesCount,
}) {
  return (
    <section className="relative overflow-hidden rounded-[2rem] bg-slate-950 p-5 text-white shadow-xl shadow-slate-950/10 sm:p-6">
      <div className="pointer-events-none absolute -right-16 -top-16 h-44 w-44 rounded-full bg-sky-500/30 blur-3xl" />
      <div className="pointer-events-none absolute -bottom-20 -left-20 h-48 w-48 rounded-full bg-orange-500/25 blur-3xl" />

      <div className="relative">
        <div className="flex items-center gap-2 text-xs font-black uppercase tracking-[0.24em] text-sky-200">
          <FaBookOpen />
          Bibliothèque technique
        </div>

        <div className="mt-3 flex flex-col gap-5 lg:flex-row lg:items-end lg:justify-between">
          <div className="max-w-2xl">
            <h2 className="text-2xl font-black tracking-tight sm:text-3xl">
              Judo, Jujitsu et passage de grade
            </h2>

            <p className="mt-2 text-sm leading-6 text-slate-200">
              Recherchez rapidement une technique, consultez sa fiche,
              écoutez sa prononciation japonaise et entraînez-vous au
              programme UV2.
            </p>

            <div className="mt-4 inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/10 px-3 py-2 text-xs font-bold text-slate-200 backdrop-blur">
              <FaVolumeUp className="text-sky-300" />
              Prononciation japonaise intégrée
            </div>
          </div>

          <div className="grid grid-cols-3 gap-2 lg:min-w-[370px]">
            <HeroStat
              icon={FaLayerGroup}
              label="Total"
              value={totalCount}
            />

            <HeroStat
              icon={FaSearch}
              label="Affichées"
              value={filteredCount}
            />

            <HeroStat
              icon={FaBookOpen}
              label="Familles"
              value={familiesCount}
            />
          </div>
        </div>
      </div>
    </section>
  );
}

function HeroStat({
  icon: Icon,
  label,
  value,
}) {
  return (
    <div className="rounded-2xl border border-white/10 bg-white/10 p-3 text-center backdrop-blur">
      <div className="mx-auto flex h-9 w-9 items-center justify-center rounded-xl bg-white/15">
        <Icon className="text-sm" />
      </div>

      <p className="mt-2 text-lg font-black leading-none">
        {value}
      </p>

      <p className="mt-1 text-[10px] font-semibold text-slate-300 sm:text-[11px]">
        {label}
      </p>
    </div>
  );
}